<template>
  <div ref="zoom" class="auto-zoom">
    <span>{{ text }}</span>
  </div>
</template>
<script>
export default {
  name: "autoZoom",
  data() {
    return {};
  },
  props: {
    distance: {
      type: Number,
      default: 1.2,
    },
    text: {
      default: "",
    },
  },
  watch: {
    text(v, o) {
      this.text = v;
      if (v.length > o.length) {
        this.$nextTick(() => {
          this.reset();
        });
      }
    },
  },
  mounted() {
    this.reset();
  },
  methods: {
    reset() {
      const dom = this.$refs.zoom;
      let lay = dom.offsetWidth; //获取外层div实际宽度
      let span = dom.children[0].offsetWidth; //获取子元素span的文本实际宽度
      //获取每个文本的平均宽度
      let average = span / dom.children[0].innerHTML.split("").length;
      //如果span 加上 大约1.2个average > lay, (加上1.2个average 使文本不那么拥挤前开始缩小)
      if (span + average * this.distance > lay) {
        //使用scale缩小，假设为s;
        //缩小运算等式 span * s + average * this.distance = lay;
        //所以s为
        let s = (lay - average * this.distance) / span;
        //设置scale
        dom.style.transform = `scale(${s})`;
        //实际开发中，还遇到的问题是，span > lay 文本不居中
        if (span > lay) {
          dom.children[0].style.marginLeft = (lay - span) / 2 + "px";
        }
      }
    },
  },
};
</script>

<style scoped lang="less">
// 父级需要提供固定的宽度
.auto-zoom {
  width: 100%;
  span {
    white-space: nowrap;
  }
}
</style>
